<span [class.hide-on-init]="hideOnInit"
      [class.page-loader]="pageLoader"
      [class.page-overlay]="pageOverlay"
      [class.show]="showLoading || showLoadingSuccess || showLoadingError"
      [class]="theme"
      [ngStyle]="{
      'width' : iconSize.toString() + 'px',
      'height': iconSize.toString() + 'px',
      }"
      class="work-ui-loading-spinner work-loading-element">
    <work-ui-icon [class.hide]="!showLoading"
                  [class.loading]="showLoading"
                  [fontSize]="iconSize"
                  class="work-ui-loading-spinner__loader work-loading-element"
                  name="progress_activity">
    </work-ui-icon>
    <work-ui-icon [class.hide]="!showLoadingSuccess"
                  [class.show]="showLoadingSuccess"
                  [fontSize]="iconSize"
                  class="work-ui-loading-spinner__success work-loading-element"
                  name="check">
    </work-ui-icon>
   <work-ui-icon [class.hide]="!showLoadingError"
                 [class.show]="showLoadingError"
                 [fontSize]="iconSize"
                 class="work-ui-loading-spinner__error work-loading-element"
                 name="report">
    </work-ui-icon>
  </span>
